import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectRegime = ({ selectedRegime, onChange, getData, disabled }) => {
  const { translate: t } = useDictionaryTranslation();
  const [regimes, setRegimes] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectRegime = (item) => {
    const regime = regimes.find((d) => d._id === item.value);
    onChange(regime);
  };

  const getRegimes = useCallback(
    async (search) => {
      setLoading(true);
      try {
        const params = { search, isServiceCreation: true };
        const { regimes: regimesList } = await getData(params);
        setRegimes(regimesList);
      } catch (error) {
        setRegimes([]);
      } finally {
        setLoading(false);
      }
    },
    [getData],
  );

  const getOptionData = useCallback((regime) => {
    return {
      value: regime._id,
      label: regime.description,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t('regimePlaceholder')}
      isLoading={loading}
      onChange={selectRegime}
      options={regimes}
      value={selectedRegime}
      onSearch={getRegimes}
      getOptionData={getOptionData}
      disabled={disabled}
    />
  );
};

SelectRegime.propTypes = {
  selectedRegime: PropTypes.shape({
    description: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  getData: PropTypes.func,
  disabled: PropTypes.bool,
};

SelectRegime.defaultProps = {
  getData: InteroperableDataService.getRegimes,
};
